import { QueryKeys } from "../../utils/queryKeys";

export const finalAssessmentQuestionKeys = {
  all: [QueryKeys.FINAL_ASSESSMENT_QUESTION],

  getFinalAssessmentQuestionKeys: (args) => {
    const { userId , userTypeId } = args;

    return [...finalAssessmentQuestionKeys.all, userTypeId ,userId];
  },
};
